module.exports = __webpack_public_path__ + "static/media/image_app_download_ios.57cd01ac.png";